module.exports = __webpack_public_path__ + "static/media/seat-icon-gray.10830d28.svg";